import { useEffect, useRef } from 'react';

import useWatch from '../useWatch';

export function useResizeObserver<T extends HTMLElement>(
  target: React.RefObject<T | null>,
  callback: globalThis.ResizeObserverCallback,
  option: ResizeObserverOptions = {},
) {
  const observerRef = useRef<ResizeObserver>(null);

  const stop = () => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
  };

  useWatch(
    target.current,
    target => {
      stop();

      observerRef.current = new ResizeObserver(callback);

      if (target) observerRef.current!.observe(target, option);
    },
    { immediate: true },
  );

  useEffect(() => {
    return () => stop();
  }, []);

  return {
    stop,
  };
}
